import { render, staticRenderFns } from "./sendNewYearCardLastStep.vue?vue&type=template&id=53469987"
import script from "./sendNewYearCardLastStep.vue?vue&type=script&lang=js"
export * from "./sendNewYearCardLastStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53469987')) {
      api.createRecord('53469987', component.options)
    } else {
      api.reload('53469987', component.options)
    }
    module.hot.accept("./sendNewYearCardLastStep.vue?vue&type=template&id=53469987", function () {
      api.rerender('53469987', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/sendNewYearCardLastStep.vue"
export default component.exports